import styled from 'styled-components';

interface ActionsFabProps {
  style?: any;
}

export const Container = styled.div`
  > button {
    position: fixed;
    bottom: 8rem;
    right: 3rem;
    width: 75px;
    height: 75px;
    background: ${props => props.theme.primaryColor};
    color: #fff;
    z-index: 9;
    transform: scale(1) translate3d(0, 0, 0);
    transition: ease-out 0.3s;

    &.show {
      transform: scale(0) translate3d(0, 0, 0);
    }

    &:hover {
      background: ${props => props.theme.primaryColor};
      transform: scale(1.1, 1.1) translate3d(0, 0, 0);
    }
  }

  @media (max-width: 768px) {
    > button {
      bottom: 1.5rem;
      right: 1.5rem;

      &:hover {
        transform: scale(1, 1) translate3d(0, 0, 0);
      }
    }
  }
`;

export const ActionsFab = styled.div<ActionsFabProps>`
  position: fixed;
  bottom: 8.2rem;
  right: 3.2rem;
  display: flex;
  flex-direction: column;
  z-index: 9;
  visibility: hidden;

  button {
    width: 70px;
    height: 70px;
    background: ${props => props.theme.primaryColor};
    color: #fff;
    transition: 0.3s ease-in-out;
    position: relative;

    &:disabled {
      pointer-events: auto;
    }

    &:hover {
      background: ${props => props.theme.primaryColor};

      &:disabled {
        .tooltip {
          display: none;
        }

        &:before {
          content: 'Sem informações para exibir';
          position: absolute;
          background: #fff;
          color: #555;
          border: 1px solid #ccc;
          right: 96%;
          white-space: nowrap;
          text-align: left;
          border-radius: 4px;
          padding: 0.5rem 1rem;
          transform: translateX(-20px);
          transition: 0.3s ease-in-out;
          position: absolute;
          z-index: 1;
          text-transform: capitalize;
          font-size: 14px !important;
        }

        &:after {
          content: '';
          position: absolute;
          top: 50%;
          right: 110%;
          margin-top: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: transparent transparent transparent #ccc;
        }
      }
    }

    &:nth-child(1) {
      bottom: -8rem;
      opacity: 0;
      visibility: none;

      &.active {
        bottom: 6rem;
        opacity: 1;
        visibility: visible;
      }
    }

    &:nth-child(2) {
      bottom: -5rem;
      opacity: 0;
      visibility: none;

      &.active {
        bottom: 5.3rem;
        opacity: 1;
        visibility: visible;
      }
    }

    .tooltip {
      visibility: hidden;
      width: 120px;
      background-color: #fff;
      color: #555;
      border: 1px solid #ccc;
      text-align: center;
      border-radius: 4px;
      padding: 5px 0;
      transform: translateX(-20px);
      transition: 0.3s ease-in-out;
      opacity: 0;
      position: absolute;
      z-index: 1;
      right: 135%;

      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 100%;
        margin-top: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent transparent #ccc;
      }
    }

    &:hover .tooltip {
      transform: translateX(0px);
      visibility: visible;
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    bottom: 6.5rem;
    right: 1.7rem;

    button {
      .tooltip {
        transform: translateX(0px);
        visibility: visible;
        opacity: 1;
      }
    }
  }
`;

export const Hamburger = styled.label`
  pointer-events: none;

  span {
    width: 25px;
    height: 3px;
    background: white;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -12.5px;
    margin-top: -1.5px;
    transition: transform 200ms;
  }

  .hamburger-1 {
    transform: translate3d(0, -8px, 0);
  }

  .hamburger-2 {
    transform: translate3d(0, 0, 0);
  }

  .hamburger-3 {
    transform: translate3d(0, 8px, 0);
  }

  .hamburger-1.active {
    transform: translate3d(0, 0, 0) rotate(45deg);
  }
  .hamburger-2.active {
    transform: translate3d(0, 0, 0) scale(0.1, 1);
  }
  .hamburger-3.active {
    transform: translate3d(0, 0, 0) rotate(-45deg);
  }
`;

export const DataWrapper = styled.div`
  &:not(:first-child) {
    margin-top: 1rem;
  }
`;

export const DataFile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1rem;
`;
